module.exports = __webpack_public_path__ + "report_consumo512.png";